export default __webpack_public_path__ + "static/hero2-d224df348d263dd8ffdc06c56f4a160f.png";